var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.096,
    height: 15.118,
    viewBox: "0 0 15.096 15.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47974",
    "data-name": "Group 47974",
    transform: "translate(-511 -5951.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47973",
    "data-name": "Group 47973",
    transform: "translate(511 5951.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47972",
    "data-name": "Group 47972",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-call"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47971",
    "data-name": "Group 47971",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M12.281,35.9A1.487,1.487,0,0,0,11.2,35.4a1.538,1.538,0,0,0-1.091.491L9.1,36.9c-.083-.045-.166-.086-.246-.128-.115-.057-.223-.112-.316-.169a10.958,10.958,0,0,1-2.626-2.393,6.465,6.465,0,0,1-.861-1.359c.262-.239.5-.488.74-.727.089-.089.179-.182.268-.271a1.464,1.464,0,0,0,0-2.208l-.871-.871c-.1-.1-.2-.2-.3-.3-.191-.2-.392-.4-.6-.593a1.51,1.51,0,0,0-1.069-.469,1.563,1.563,0,0,0-1.085.469l-.006.006L1.05,28.976a2.334,2.334,0,0,0-.692,1.484,5.593,5.593,0,0,0,.408,2.367A13.738,13.738,0,0,0,3.207,36.9a15.015,15.015,0,0,0,5,3.915,7.79,7.79,0,0,0,2.808.83c.067,0,.137.006.2.006a2.4,2.4,0,0,0,1.841-.791c0-.006.01-.01.013-.016a7.254,7.254,0,0,1,.558-.578c.137-.131.278-.268.415-.412a1.592,1.592,0,0,0,.482-1.1,1.533,1.533,0,0,0-.491-1.094Zm1.142,3.36s0,0,0,0c-.124.134-.252.255-.389.389a8.39,8.39,0,0,0-.616.638,1.538,1.538,0,0,1-1.2.507c-.048,0-.1,0-.147,0a6.92,6.92,0,0,1-2.489-.747,14.173,14.173,0,0,1-4.709-3.688,12.953,12.953,0,0,1-2.3-3.826,4.556,4.556,0,0,1-.357-2,1.465,1.465,0,0,1,.44-.948l1.088-1.088a.725.725,0,0,1,.485-.227.682.682,0,0,1,.466.223l.01.01c.195.182.38.37.574.571.1.1.2.2.3.309l.871.871a.609.609,0,0,1,0,.989c-.093.093-.182.185-.274.274-.268.274-.523.53-.8.779-.006.006-.013.01-.016.016a.651.651,0,0,0-.166.724l.01.029a6.993,6.993,0,0,0,1.031,1.681l0,0a11.711,11.711,0,0,0,2.833,2.578,4.357,4.357,0,0,0,.392.214c.115.057.223.112.316.169.013.006.026.016.038.022a.692.692,0,0,0,.316.08.682.682,0,0,0,.485-.22L10.715,36.5a.722.722,0,0,1,.482-.239.65.65,0,0,1,.459.233l.006.006,1.758,1.758A.631.631,0,0,1,13.423,39.256Z",
    transform: "translate(-0.344 -26.532)",
    fill: "#0538bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M245.3,86.78a4.106,4.106,0,0,1,3.344,3.344.428.428,0,0,0,.424.357.569.569,0,0,0,.073-.006.431.431,0,0,0,.354-.5,4.965,4.965,0,0,0-4.046-4.046.433.433,0,0,0-.5.351A.426.426,0,0,0,245.3,86.78Z",
    transform: "translate(-237.139 -83.184)",
    fill: "#0538bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M255.938,6.669A8.176,8.176,0,0,0,249.276.007a.43.43,0,1,0-.14.849,7.3,7.3,0,0,1,5.954,5.954.428.428,0,0,0,.424.357.57.57,0,0,0,.073-.006A.423.423,0,0,0,255.938,6.669Z",
    transform: "translate(-240.849 0)",
    fill: "#0538bc"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.c6c124894092ba6a7e041fc5f589baa4.svg";
export { ForwardRef as ReactComponent };